import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { ReactNode } from "react";
import { Banner } from "../branding/Banner";

interface Props {
  /** The components to display in the filter bar. */
  filters: ReactNode | ReactNode[];
  /** The minimum width of the filter components before hiding the optional branding content. */
  filterMinWidth?: number;
  /** The maximum width of the filter components. */
  filterMaxWidth?: number;
  minHeight?: number;
  /** The components to display in the content area. */
  content: ReactNode | ReactNode[];
  isMobile?: boolean;
}

/**
 * A vertical stack layout with filters on the top and content on the bottom.  Provides
 * a divider between the filters and content as well as a banner to display Fairfleet branding.
 */
export function FilterStackLayout({
  filters,
  filterMaxWidth,
  content,
  minHeight,
  isMobile,
}: Props) {
  return (
    <Stack sx={{ height: "100%", width: "100%" }}>
      <Stack
        sx={{
          p: 2,
          minHeight,
          overflow: "visible",
        }}
        gap={2}
        direction="row"
      >
        <Stack flexGrow={1} gap={2} direction="row">
          <Stack
            sx={{ maxWidth: filterMaxWidth }}
            flexGrow={1}
            gap={2}
            direction="row"
            width="100%"
          >
            {filters}
          </Stack>
        </Stack>
        {!isMobile && (
          <>
            <Divider orientation="vertical" />
            <Banner width={140} height={50} />
          </>
        )}
      </Stack>

      <Divider />

      {content}
    </Stack>
  );
}
